import ModuleSixSelfEvaluation from "../../../../src/components/forms/ModuleSixSelfEvaluation";
import ModuleSixSelfEvaluationPart2 from "../../../../src/components/forms/ModuleSixSelfEvaluationPart2";
import * as React from 'react';
export default {
  ModuleSixSelfEvaluation,
  ModuleSixSelfEvaluationPart2,
  React
};